import { t } from "@/i18n/ko";

// 대화 목록 시각(대화 목록 설계 D8, client-detail 0.5 예외): 1분 안 "방금" · 오늘 "오후 8:12" · 어제 "어제" · 올해 "10.12" · 그 전 "2025.10.12". 기기 로컬 시각 기준.
const clock = new Intl.DateTimeFormat("ko-KR", { hour: "numeric", minute: "2-digit" });
const pad = (n: number) => String(n).padStart(2, "0");
const sameDay = (a: Date, b: Date) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

export function formatRelative(iso: string, now: Date = new Date()): string {
  const d = new Date(iso);
  if (now.getTime() - d.getTime() < 60_000) return t("time.justNow");
  if (sameDay(d, now)) return clock.format(d);
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  if (sameDay(d, yesterday)) return t("time.yesterday");
  const md = `${pad(d.getMonth() + 1)}.${pad(d.getDate())}`;
  return d.getFullYear() === now.getFullYear() ? md : `${d.getFullYear()}.${md}`;
}
